const mediaItems = [
  {
    title: '《长安十二时辰》幕后特辑',
    desc: '导演讲述拍摄背后的故事，还原大唐盛世的每一个细节',
    duration: '12:30',
    imageUrl: 'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20film%20set%20of%20historical%20Chinese%20drama%2C%20director%20directing%20actors%20in%20traditional%20costume%2C%20warm%20cinematic%20lighting%2C%20professional%20film%20production%2C%20golden%20hour%20on%20set&width=800&height=450&seq=media-01-2026&orientation=landscape',
    alt: '长安十二时辰幕后特辑',
  },
  {
    title: '《首尔告白》OST 音乐特辑',
    desc: '全剧15首原创OST一次听完，治愈你的每一个夜晚',
    duration: '25:00',
    imageUrl: 'https://readdy.ai/api/search-image?query=Music%20recording%20studio%20with%20warm%20ambient%20lighting%2C%20piano%20and%20guitar%2C%20soft%20romantic%20atmosphere%2C%20Korean%20drama%20OST%20recording%20session%2C%20cozy%20indoor%20setting&width=800&height=450&seq=media-02-2026&orientation=landscape',
    alt: '首尔告白OST音乐特辑',
  },
  {
    title: '《深海密码》制作揭秘',
    desc: '特效团队展示令人震撼的海底场景是如何打造的',
    duration: '08:45',
    imageUrl: 'https://readdy.ai/api/search-image?query=Visual%20effects%20studio%20with%20large%20monitors%20showing%20underwater%20scenes%2C%20artists%20working%20on%20CGI%2C%20blue%20ambient%20lighting%2C%20professional%20post%20production%20environment&width=800&height=450&seq=media-03-2026&orientation=landscape',
    alt: '深海密码制作揭秘',
  },
  {
    title: '《山河故人》经典片段回顾',
    desc: '精选全剧最动人的十个场景，每一帧都值得珍藏',
    duration: '18:20',
    imageUrl: 'https://readdy.ai/api/search-image?query=Nostalgic%20family%20dinner%20scene%20in%20traditional%20Chinese%20home%2C%20warm%20candle%20lighting%2C%20emotional%20family%20gathering%2C%20vintage%201980s%20interior%2C%20golden%20warm%20tones&width=800&height=450&seq=media-04-2026&orientation=landscape',
    alt: '山河故人经典片段回顾',
  },
  {
    title: '《职场风云录》主演专访',
    desc: '男女主角畅谈角色塑造，分享职场剧拍摄的趣事',
    duration: '15:00',
    imageUrl: 'https://readdy.ai/api/search-image?query=Professional%20interview%20setup%20with%20two%20actors%20sitting%20on%20modern%20sofa%2C%20warm%20studio%20lighting%2C%20casual%20conversation%20atmosphere%2C%20clean%20contemporary%20interior%2C%20film%20posters%20in%20background&width=800&height=450&seq=media-05-2026&orientation=landscape',
    alt: '职场风云录主演专访',
  },
];

export default function Media() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-3">
            视频专区
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            幕后花絮、OST特辑、专访精彩集锦，发现剧集背后的故事
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {mediaItems.map((item) => (
            <div
              key={item.title}
              className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-all duration-300"
            >
              <div className="relative h-44 overflow-hidden">
                <img
                  src={item.imageUrl}
                  alt={item.alt}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                    (target.parentElement as HTMLElement).style.display = 'none';
                  }}
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/35 transition-colors flex items-center justify-center">
                  <span className="w-12 h-12 flex items-center justify-center rounded-full bg-white/90 group-hover:bg-primary-500 group-hover:text-white transition-all text-primary-500">
                    <i className="ri-play-fill text-xl"></i>
                  </span>
                </div>
                <div className="absolute bottom-2 right-2 px-2 py-0.5 text-[10px] font-medium rounded bg-black/60 text-white whitespace-nowrap">
                  {item.duration}
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-heading font-semibold text-foreground-800 mb-1 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}